import _ from 'lodash';
import { evaluate } from 'mathjs';

export const checkValue = value => {
    return _.isNumber(_.toNumber(value));
};

const suma = arr => {
    let count = 0;

    arr.forEach((elem, idx) => {
        const indeks = ++idx;
        count += Math.pow(elem, indeks);
    });

    return count;
};

export const countRentLongPrice = params => {
    const { a, b, c, d, e, f, h, i } = params;

    if (!a || !b || !c || !d || !e || !f || !h || !i) {
        return '';
    }

    const procent = liczba => {
        return liczba / 100;
    };

    const i_elem = _.get(i, `i_${f}_${h}`);
    const firstElement = (1 - procent(a) + procent(b) - procent(e)) * d;
    const firstElement2 = firstElement - procent(i_elem) * d;

    if (firstElement2 < 0) {
        return '';
    }

    const secondElement = suma(
        new Array(parseInt(f)).fill(1 / (1 + procent(c) / 12))
    );
    const thirdElement = procent(i_elem) * d * (procent(c) / 12);

    const summary = firstElement2 / secondElement + thirdElement;

    return isNaN(summary) ? 0 : summary;
};

export const countLeasingPrice = params => {
    const { a, b, c, d, e, f, g } = params;

    if (!a || !b || !c || !d || !e || !f || !g) {
        return '';
    }

    const procent = liczba => {
        return liczba / 100;
    };

    const firstElement = evaluate(
        `(1 - ${procent(a)} + ${procent(b)} - ${procent(e)}) * ${d} - ${g}`
    );

    const secondElement = suma(
        new Array(parseInt(f)).fill(1 / (1 + procent(c) / 12))
    );
    const thirdElement = g * (procent(c) / 12);

    const summary = firstElement / secondElement + thirdElement;

    return isNaN(summary) ? '1000' : summary;
};
